import { fromPairs, map, dropRight } from 'lodash';

export default function encodeHeaders(headers) {
  return encodeURIComponent(JSON.stringify(fromPairs(map(dropRight(headers),
    (item) => ([item.value, item.text ? item.text : item.value])))));
}
